import React from "react";
const ArticlesCard = ({ article, delay }) => {
    const articlePath = `/blog/${article.slug || article.id}`;

    return (
        <a
            href={articlePath}
            className={`reveal ${delay} group block relative bg-white dark:bg-surface-dark rounded-[2.5rem] border border-gray-100 dark:border-gray-800 shadow-soft hover:shadow-hover transition-all duration-500 overflow-hidden hover:-translate-y-2 h-full flex flex-col`}
        >
            {/* 1. Thumbnail with Depth Effect */}
            <div className="relative aspect-[16/10] overflow-hidden">
                <img
                    src={article.thumbnail}
                    alt={article.title}
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                />

                {/* Glassmorphism Category Tag */}
                <div className="absolute top-5 left-5 z-10">
                    <span className="px-4 py-1.5 rounded-full bg-white/80 dark:bg-black/60 backdrop-blur-md text-primary text-[10px] font-black uppercase tracking-widest border border-white/20 dark:border-white/10">
                        {article.tags[0]}
                    </span>
                </div>

                {/* Hover Overlay Arrow */}
                <div className="absolute inset-0 bg-primary/10 opacity-0 group-hover:opacity-100 transition-opacity duration-500 flex items-center justify-center">
                    <div className="size-14 rounded-full bg-white dark:bg-primary flex items-center justify-center shadow-xl translate-y-4 group-hover:translate-y-0 transition-transform duration-500">
                        <span className="material-symbols-outlined text-primary dark:text-white text-2xl">
                            north_east
                        </span>
                    </div>
                </div>
            </div>

            {/* 2. Content Area */}
            <div className="p-8 flex flex-col flex-grow relative">
                <div className="flex-grow">
                    <h3 className="text-xl font-bold text-[#0d121b] dark:text-white mb-4 group-hover:text-primary transition-colors font-display leading-[1.3] line-clamp-2">
                        {article.title}
                    </h3>
                    <p className="text-gray-500 dark:text-gray-400 text-[14px] mb-8 leading-relaxed line-clamp-3 font-medium">
                        {article.excerpt}
                    </p>
                </div>

                {/* 3. Refined Footer */}
                <div className="flex items-center justify-between pt-6 border-t border-gray-100 dark:border-gray-800 mt-auto">
                    <div className="flex items-center gap-2">
                        <div className="size-2 rounded-full bg-primary/40 animate-pulse"></div>
                        <span className="text-[10px] font-bold text-gray-400 dark:text-gray-500 uppercase tracking-widest">
                            {article.publishedDate}
                        </span>
                    </div>

                    <div className="flex items-center gap-1.5 text-[10px] font-black text-gray-400 dark:text-gray-500 uppercase tracking-tighter">
                        <span className="material-symbols-outlined text-[14px]">
                            pace
                        </span>
                        {article.readTime}
                    </div>
                </div>
            </div>

            {/* Interaction Glow - Follows Theme */}
            <div className="absolute top-0 right-0 w-32 h-32 bg-primary/5 rounded-bl-full translate-x-12 -translate-y-12 group-hover:translate-x-0 group-hover:translate-y-0 transition-transform duration-700 ease-out pointer-events-none"></div>
        </a>
    );
};

export default ArticlesCard;